import { ReactNode, useState } from 'react'

import { Transition } from '@headlessui/react'

interface Props {
  children: ReactNode
  showPanel: boolean
}

const PopoverPanel = ({ children, showPanel }: Props) => {
  const [firstExecution, setFirstExecution] = useState<boolean>(true)

  const handleAfterEnter = () => {
    setFirstExecution(false)
  }

  return (
    <div
      className="flex flex-col gap-y-6 mx-auto pb-28 px-4 py-6 max-w-7xl text-gray-800 sm:px-6"
      key="top-nav-menu"
    >
      <Transition
        appear={showPanel}
        key="sub"
        enter={`transition transform duration-300 ${
          firstExecution ? 'delay-300' : ''
        }`}
        afterEnter={handleAfterEnter}
        enterFrom="opacity-0 translate-x-1/3"
        enterTo="opacity-100 translate-x-0"
        leave="transition transform duration-300"
        leaveFrom="opacity-100 translate-x-0"
        leaveTo="opacity-0 translate-x-1/3"
        show={showPanel}
      >
        {children}
      </Transition>
    </div>
  )
}

export default PopoverPanel
